exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pad[data-v-0bc6b980]{padding:.04rem .32rem}.search-box[data-v-0bc6b980]{padding:.24rem .32rem;border-bottom:1px solid #f0f0f0}.search-box .search-title[data-v-0bc6b980]{font-size:.22rem;font-weight:bold}.search-box .search-item[data-v-0bc6b980]{margin-left:.24rem}", ""]);

// exports
